import { useContext } from "react";
import { PageNewState, TicketDetailPageContext } from "./";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(TicketDetailPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
